/* global window */
import React, { Component } from 'react';
// components
import CardTitlePart from '../../parts/CardTitlePart';
import TextCTA from '../../layout/buttons/TextCTA';
import HtmlPart from '../../parts/HtmlPart';
import CardBannerPart from '../../parts/CardBannerPart';

// functions
import { makeSafe } from '../../services/cloudinaryService';

class MarketingNewsCard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
    this.handleVideoRestart = this.handleVideoRestart.bind(this);
    this.renderCTA = this.renderCTA.bind(this);
    this.renderVideoRestartCTA = this.renderVideoRestartCTA.bind(this);
    this.renderLinkCTA = this.renderLinkCTA.bind(this);
    this.renderExpanderCTA = this.renderExpanderCTA.bind(this);
    this.expandCard = this.expandCard.bind(this);

    this.CTA_TYPES = {
      expander: this.renderExpanderCTA,
      link: this.renderLinkCTA,
      videoRestart: this.renderVideoRestartCTA
    };
  }

  handleVideoRestart() {
    this.bannerPart.restartVideo();
  }

  expandCard() {
    this.setState({ expanded: !this.state.expanded });
  }

  renderCTA(type, text, ctaLink, ctaTextAlt, linkCtaAsNewTab) {
    return this.CTA_TYPES[type](text, ctaLink, ctaTextAlt, linkCtaAsNewTab);
  }

  renderVideoRestartCTA() {
    const { ctaText } = this.props;
    return (
      <div className="c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          onBtnClick={this.handleVideoRestart}
          text={ctaText}
          type={'confirm'}
        />
      </div>
    );
  }

  renderExpanderCTA() {
    const { ctaText, ctaTextAlt } = this.props;
    const { expanded } = this.state;
    const alternateText = ctaTextAlt || ctaText;
    return (
      <div className="c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          onBtnClick={this.expandCard}
          text={expanded ? alternateText : ctaText}
          type={expanded ? 'shrink' : 'expand'}
        />
      </div>
    );
  }

  renderLinkCTA(text, ctaLink = '#', ctaTextAlt, linkCtaAsNewTab = false) {
    return (
      <div className="c-event-feed__card__splitter u-flex-justify-end">
        <TextCTA
          onBtnClick={() => {
            if(linkCtaAsNewTab) window.open(makeSafe(ctaLink), '_blank');
            else window.location.replace(makeSafe(ctaLink));
          }}
          text={text}
          type={'confirm'}
        />
      </div>
    );
  }

  render() {
    const { title, headerVideoLink, headerImage, headerImageAltText, aboveFoldText = '', belowFoldText,
      hasCta, ctaText, ctaTextAlt, ctaType, ctaLink, linkCtaAsNewTab, headerOverlayText } = this.props;
    const { expanded } = this.state;
    // change me for passed in or generated props

    return (
      <div className="u-padding-bottom-small">

        <CardTitlePart title={title} />

        <CardBannerPart
          imageSrc={headerImage}
          imageAltText={headerImageAltText}
          videoSrc={headerVideoLink}
          videoAltText={headerImageAltText}
          onRef={(ref) => { this.bannerPart = ref; }}
          overlayText={headerOverlayText}
        />

        {
          !!parseInt(hasCta, 10) ? (
            this.renderCTA(ctaType[0], ctaText, ctaLink, ctaTextAlt, linkCtaAsNewTab)
          ) : null
        }

        <div className="u-padding-x-small u-padding-top-small">
          <HtmlPart htmlString={aboveFoldText} />
        </div>

        {
          expanded && (
            <div className="u-padding-x-small">
              <HtmlPart htmlString={belowFoldText} />
            </div>
          )
        }

      </div>
    );
  }
}

export default MarketingNewsCard;



// WEBPACK FOOTER //
// ./src/cards/templates/MarketingCard.js